// ============================================================
// PayRocky - FAQ Page
// ============================================================

import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { PublicLayout, PageContainer, SectionHeading } from '../components/layout/Layout';
import { FAQ_DATA, SUPPORT_EMAIL } from '../data/constants';
import { useSupportEmail } from '../hooks/useSupportEmail';

export default function FAQPage() {
  const [open, setOpen] = useState(null);
  const supportEmail = useSupportEmail(SUPPORT_EMAIL);

  return (
    <PublicLayout>
      <PageContainer style={{ maxWidth: '760px' }}>
        <SectionHeading
          tag="FAQ"
          title="Frequently asked questions"
          subtitle="Everything you need to know about trading on PayRocky."
        />

        <div style={{ display: 'grid', gap: '10px' }}>
          {FAQ_DATA.map((item, index) => (
            <div
              key={index}
              style={{
                background: 'var(--clr-surface)',
                border: `1px solid ${open === index ? 'var(--clr-accent-glow)' : 'var(--clr-border)'}`,
                borderRadius: 'var(--radius-lg)',
                overflow: 'hidden',
                transition: 'border-color 0.2s ease',
              }}
            >
              <button
                onClick={() => setOpen(open === index ? null : index)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '1rem 1.1rem',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                  gap: '12px',
                }}
              >
                <span style={{ fontSize: '14px', fontWeight: 700, color: open === index ? 'var(--clr-accent)' : 'var(--clr-text)', lineHeight: 1.5 }}>
                  {item.q}
                </span>
                <ChevronDown
                  size={16}
                  style={{
                    color: 'var(--clr-text-3)',
                    flexShrink: 0,
                    transform: open === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease',
                  }}
                />
              </button>

              {open === index ? (
                <div
                  style={{
                    padding: '12px 1.1rem 1rem',
                    fontSize: '13px',
                    color: 'var(--clr-text-2)',
                    lineHeight: 1.75,
                    borderTop: '1px solid var(--clr-border)',
                    wordBreak: 'break-word',
                  }}
                >
                  {item.a}
                </div>
              ) : null}
            </div>
          ))}
        </div>

        <div
          style={{
            marginTop: '2rem',
            padding: '1.35rem',
            background: 'var(--clr-surface)',
            border: '1px solid var(--clr-border)',
            borderRadius: 'var(--radius-xl)',
            textAlign: 'center',
          }}
        >
          <div style={{ fontFamily: 'var(--font-display)', fontSize: '16px', fontWeight: 700, marginBottom: '6px' }}>
            Still have questions?
          </div>
          <div style={{ fontSize: '13px', color: 'var(--clr-text-2)', marginBottom: '1rem', lineHeight: 1.7 }}>
            Reach out to PayRocky support for help with your account, transactions, or general questions.
          </div>
          <a
            href={`mailto:${supportEmail}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '10px 20px',
              background: 'var(--clr-accent)',
              color: '#0a0a0b',
              borderRadius: 'var(--radius-md)',
              fontSize: '13px',
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Contact support
          </a>
        </div>
      </PageContainer>
    </PublicLayout>
  );
}
